
import { ReturnPurposeEnum, ShiftEnum } from '@needle-management/shared-models';
import { ApiProperty } from '@nestjs/swagger';
export class NeedleReturnAfterProductionDto {

  @ApiProperty()
  id: number;

  @ApiProperty()
  jobId: number;

  @ApiProperty()
  returnQty: string;

  @ApiProperty()
  returnTo: string;

  @ApiProperty()
  returnBy: string;

  @ApiProperty()
  remainingQty: string;

  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  createdAt : Date;

  @ApiProperty()
  createdUser : string;
  
  @ApiProperty()
  updatedAt : Date;

  @ApiProperty()
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty()
  companyCode: string; 

  @ApiProperty()
  returnPurpose: ReturnPurposeEnum;

  @ApiProperty()
  shifts: ShiftEnum;

  @ApiProperty()
  dateOfReturn: string;

  @ApiProperty()  
  noOfPieces: string;
}

